module.exports = __webpack_public_path__ + "f8505bd4d6f3e3aa435b72d1c045d4a7.png";